<template>
  <div class="border-beige-academy-300 border-2 border-dashed font-light px-20 py-10
  rounded text-center lg:text-xl w-full relative bg-beige-academy-100
  text-chocolate-academy-600 text-base"
    @dragenter.prevent="onDragEnter"
    @dragleave.prevent="onDragLeave"
    @dragover.prevent
    @drop.prevent.stop="onDrop"
    :class="{dragging: isDragging}">

    <div class="absolute w-full bg-white top-0 left-0 rounded-t-lg p-6 pb-4 text-right"
      v-show="file">
      <div class="upload-control">
          <label for="file">{{ $t('upload.selectImage') }}</label>
          <button @click.prevent="upload" :class="{loader: loading}">
            {{ $t('upload.upload') }}
          </button>
      </div>
    </div>

    <div class="uploader" v-if="!file">
      <p>{{ $t('upload.dragImage') }}</p>
      <div>{{ $t('upload.or') }}</div>
      <div class="w-2/3 mx-auto flex flex-col relative">
        <label for="file">{{ $t('upload.select') }}</label>
        <input
          type="file"
          id="file"
          multiple
          @change="onInputChange">
      </div>
    </div>
      <div class="flex flex-wrap mt-20"
        v-else>
          <div class="flex flex-col bg-white text-chocolate-academy-600 w-full
            justify-between shadow-lg m-4">
              <div class="flex flex-col text-black text-xs text-left px-4 py-4">
                <span v-text="file.name"></span>
                <span v-text="getFileSize(file.size)"></span>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import CropProfileImage from '@/components/modals/CropProfileImage.vue';

export default {
  data: () => ({
    isDragging: false,
    dragCount: 0,
    file: null,
    loading: false,
    sharedState: {
      uploaded: false,
    },
  }),

  props: ['id'],

  methods: {
    ...mapActions({
      updatedSlots: 'slots/updatedSlots',
    }),

    onDragEnter() {
      this.dragCount += 1;
      this.isDragging = true;
    },
    onDragLeave() {
      this.dragCount -= 1;

      if (this.dragCount <= 0) { this.isDragging = false; }
    },
    onDrop(e) {
      this.isDragging = false;

      const { files } = e.dataTransfer;

      Array.from(files).forEach((file) => this.addFile(file));
    },
    onInputChange(e) {
      const { files } = e.target;

      Array.from(files).forEach((file) => this.addFile(file));
    },
    addFile(file) {
      if (!file.type.match('image')) {
        this.createNotification('error', `${file.name} ${this.$t('upload.notImage')}`);
        return;
      }

      this.file = file;

      const reader = new FileReader();

      reader.readAsDataURL(file);
    },
    getFileSize(givenSize) {
      let size = givenSize;
      const fSExt = ['Bytes', 'KB', 'MB', 'GB'];
      let i = 0;

      while (size > 900) {
        size /= 1024;
        i += 1;
      }
      return `${(Math.round(size * 100) / 100)} ${fSExt[i]}`;
    },
    upload() {
      this.loading = true;
      const formData = new FormData();

      formData.set('image', this.file);
      // formData.set('name', this.file.name);

      axios.post(`/api/users/${this.id}/profile-photo`, formData)
        .then(({ data }) => {
          this.$emit('close');
          this.loading = false;
          this.$modal.show(CropProfileImage, {
            url: data,
            userId: this.id,
          }, {
            height: 'auto',
            adaptive: true,
          });
        })
        .catch(() => {
          this.loading = false;
          this.createNotification('error', this.$t('notifications.errorTryAgain'));
        });
    },
  },
};
</script>

<style lang="scss" scoped>
    .uploader {
      label,
      input {
          @apply bg-white text-chocolate-academy-600 w-full top-0 left-0 p-4;
          @apply rounded mt-4 cursor-pointer;
      }

        input {
            opacity: 0;
            z-index: -2;
        }

        label {
            @apply absolute;
        }
    }

    .dragging {
        @apply bg-white text-chocolate-academy-600 border-beige-academy-300;

        div > label {
            @apply bg-beige-academy-300 text-white;
        }
    }

    .upload-control {
        label,
        button {
            @apply bg-beige-academy-300 text-white px-6 py-4 border-beige-academy-300 rounded;
            @apply cursor-pointer;
        }

        label {
            @apply py-5 mr-4;
        }
    }

</style>
